import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
} from "@component/dialog";
import { Button } from "@component/button";
import { MicOffIcon } from "lucide-react";

interface MicDetectionDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onOpenSettings: () => void;
}

export default function MicDetectionDialog({
    isOpen,
    onClose,
    onOpenSettings,
}: MicDetectionDialogProps) {
    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <div className="flex items-center justify-center mb-4">
                        <div className="w-16 h-16 rounded-full bg-red-100 dark:bg-red-900/20 flex items-center justify-center">
                            <MicOffIcon className="h-8 w-8 text-red-600 dark:text-red-400" />
                        </div>
                    </div>
                    <DialogTitle className="text-center text-xl">
                        Microphone Not Detected
                    </DialogTitle>
                    <DialogDescription className="text-center">
                        We couldn't detect your microphone. Please check your device settings and allow microphone access.
                        <br /><br />
                        You may try again or refresh the page.
                        <br />
                        Refreshing may reset your AI interview.
                    </DialogDescription>
                </DialogHeader>

                <div className="space-y-4">
                    {/* Action button */}
                    <Button
                        onClick={onOpenSettings}
                        className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2"
                    >
                        Check Device Settings
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}